import React, { useId, useState } from "react";
import { CameraIcon, Loader2Icon } from "lucide-react";
import type { School } from "../../types/team";
import { resizeImage } from "../../utils/image";
import { Avatar } from "../Avatar";
interface PhotoInputProps {
  name: string;
  school?: School | "mentor";
  value: string;
  onChange: (dataUrl: string) => void;
}
export function PhotoInput({
  name,
  school,
  value,
  onChange
}: PhotoInputProps) {
  const id = useId();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const pick = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!file.type.startsWith("image/")) return setError("Please choose an image.");
    setBusy(true);
    setError(null);
    try {
      onChange(await resizeImage(file));
    } catch {
      setError("Couldn't read that image. Try another one.");
    } finally {
      setBusy(false);
    }
  };
  return <div className="flex items-center gap-5" data-id="element-237" data-mp="17b03pr0m6fm6">
      <Avatar name={name} school={school} photo={value} size="xl" data-id="element-238" data-mp="17cb9fwdmdxfx" />
      <div data-id="element-239" data-mp="1c9jqtuqy1xg4">
        <div className="flex flex-wrap items-center gap-2" data-id="element-240" data-mp="1c9a024y2rm9d">
          <label htmlFor={id} className="inline-flex cursor-pointer items-center gap-2 rounded-lg border border-ink/15 bg-surface px-3 py-2 text-sm font-semibold transition-colors duration-150 hover:bg-paper" data-id="element-241" data-mp="1h7uybytrnvv6">
            {busy ? <Loader2Icon className="h-4 w-4 animate-spin" aria-hidden="true" data-id="element-242" data-mp="1q6yk5akbipdd" /> : <CameraIcon className="h-4 w-4" aria-hidden="true" data-id="element-243" data-mp="1v6b8y0ur26il" />}
            {value ? "Change photo" : "Upload photo"}
          </label>
          {value && <button type="button" onClick={() => onChange("")} className="px-2 py-2 text-sm text-muted hover:text-danger" data-id="element-244" data-mp="24y8jd5dxoug9">
              Remove
            </button>}
        </div>
        <input id={id} type="file" accept="image/*" className="sr-only" onChange={pick} data-id="element-245" data-mp="2dy3yflam19lk" />
        <p className="mt-1.5 text-xs text-muted" data-id="element-246" data-mp="etn6uffzodj6">A clear, friendly headshot works best.</p>
        {error && <p className="mt-1 text-xs text-danger" data-id="element-247" data-mp="9uiu5etuvxo3">{error}</p>}
      </div>
    </div>;
}